import { useNavigate } from "react-router-dom";

const useChangePage = () => {
  const navigate = useNavigate();

  const changePage = (pageName, state) => {
    console.log("change page function to: " + pageName);
    navigate(pageName, { state });
  };

  return changePage;
};

export default useChangePage;
